import {
    IconAlerts,
    IconAngleDownBold,
    IconAngleLeftBold,
    IconAngleRightBold,
    IconAngleUpBold,
    IconCSV,
    IconCalendar,
    IconCalendarFirst,
    IconCaretDown,
    IconCaretLeft,
    IconCaretRight,
    IconCaretUp,
    IconCaution,
    IconChat,
    IconCheckmark,
    IconCheckmarkBold,
    IconCheckmarkCircle,
    IconCheckmarkCircleAlt,
    IconChevronDownLoadMore,
    IconChevronLeft,
    IconChevronRight,
    IconClock,
    IconClose,
    IconCloseBold,
    IconDownload,
    IconEdit,
    IconEllipsis,
    IconInfo,
    IconProfile,
    IconRefresh,
    IconSchedule,
    IconSearchGlass,
    IconStar,
    IconStarFilled,
    IconTagMultiple,
    IconTagSingle,
    IconTagSingleBold
} from '../assets/icons'

const IconPreview = () => {
  const icons = [
    {
        component: <IconAlerts style={{width: '100%', height: 'auto'}} />,
        title: "IconAlerts"
    },
    {
        component: <IconAngleDownBold style={{width: '100%', height: 'auto'}} />,
        title: "IconAngleDownBold"
    },
    {
        component: <IconAngleLeftBold style={{width: '100%', height: 'auto'}} />,
        title: "IconAngleLeftBold"
    },
    {
        component: <IconAngleRightBold style={{width: '100%', height: 'auto'}} />,
        title: "IconAngleRightBold"
    },
    {
        component: <IconAngleUpBold style={{width: '100%', height: 'auto'}} />,
        title: "IconAngleUpBold"
    },
    {
        component: <IconCSV style={{width: '100%', height: 'auto'}} />,
        title: "IconCSV"
    },
    {
        component: <IconCalendar style={{width: '100%', height: 'auto'}} />,
        title: "IconCalendar"
    },
    {
        component: <IconCalendarFirst style={{width: '100%', height: 'auto'}} />,
        title: "IconCalendarFirst"
    },
    {
        component: <IconCaretDown style={{width: '100%', height: 'auto'}} />,
        title: "IconCaretDown"
    },
    {
        component: <IconCaretLeft style={{width: '100%', height: 'auto'}} />,
        title: "IconCaretLeft"
    },
    {
        component: <IconCaretRight style={{width: '100%', height: 'auto'}} />,
        title: "IconCaretRight"
    },
    {
        component: <IconCaretUp style={{width: '100%', height: 'auto'}} />,
        title: "IconCaretUp"
    },
    {
        component: <IconCaution style={{width: '100%', height: 'auto'}} />,
        title: "IconCaution"
    },
    {
        component: <IconChat style={{width: '100%', height: 'auto'}} />,
        title: "IconChat"
    },
    {
        component: <IconCheckmark style={{width: '100%', height: 'auto'}} />,
        title: "IconCheckmark"
    },
    {
        component: <IconCheckmarkBold style={{width: '100%', height: 'auto'}} />,
        title: "IconCheckmarkBold"
    },
    {
        component: <IconCheckmarkCircle style={{width: '100%', height: 'auto'}} />,
        title: "IconCheckmarkCircle"
    },
    {
        component: <IconCheckmarkCircleAlt style={{width: '100%', height: 'auto'}} />,
        title: "IconCheckmarkCircleAlt"
    },
    {
        component: <IconChevronDownLoadMore style={{width: '100%', height: 'auto'}} />,
        title: "IconChevronDownLoadMore"
    },
    {
        component: <IconChevronLeft style={{width: '100%', height: 'auto'}} />,
        title: "IconChevronLeft"
    },
    {
        component: <IconChevronRight style={{width: '100%', height: 'auto'}} />,
        title: "IconChevronRight"
    },
    {
        component: <IconClock style={{width: '100%', height: 'auto'}} />,
        title: "IconClock"
    },
    {
        component: <IconClose style={{width: '100%', height: 'auto'}} />,
        title: "IconClose"
    },
    {
        component: <IconCloseBold style={{width: '100%', height: 'auto'}} />,
        title: "IconCloseBold"
    },
    {
        component: <IconDownload style={{width: '100%', height: 'auto'}} />,
        title: "IconDownload"
    },
    {
        component: <IconEdit style={{width: '100%', height: 'auto'}} />,
        title: "IconEdit"
    },
    {
        component: <IconEllipsis style={{width: '100%', height: 'auto'}} />,
        title: "IconEllipsis"
    },
    {
        component: <IconInfo style={{width: '100%', height: 'auto'}} />,
        title: "IconInfo"
    },
    {
        component: <IconProfile style={{width: '100%', height: 'auto'}} />,
        title: "IconProfile"
    },
    {
        component: <IconRefresh style={{width: '100%', height: 'auto'}} />,
        title: "IconRefresh"
    },
    {
        component: <IconSchedule style={{width: '100%', height: 'auto'}} />,
        title: "IconSchedule"
    },
    {
        component: <IconSearchGlass style={{width: '100%', height: 'auto'}} />,
        title: "IconSearchGlass"
    },
    {
        component: <IconStar style={{width: '100%', height: 'auto'}} />,
        title: "IconStar"
    },
    {
        component: <IconStarFilled style={{width: '100%', height: 'auto'}} />,
        title: "IconStarFilled"
    },
    {
        component: <IconTagMultiple style={{width: '100%', height: 'auto'}} />,
        title: "IconTagMultiple"
    },
    {
        component: <IconTagSingle style={{width: '100%', height: 'auto'}} />,
        title: "IconTagSingle"
    },
    {
        component: <IconTagSingleBold style={{width: '100%', height: 'auto'}} />,
        title: "IconTagSingleBold"
    },
  ]; // Add other icons here

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'stretch' }}>
      {icons.map((icon, index) => (
        <div key={index} style={{ width: '200px', height: 'auto', padding: '1rem', margin: '.5rem', border: '1px solid #d1d5db' }}>
            <p style={{wordBreak: 'break-all'}}>{icon.title}</p>
            {icon.component}
        </div>
      ))}
    </div>
  );
};

export default IconPreview;
